/**
 * RR Mall APP WebView UA 判定（全主题唯一正则定义处）。
 * 提供 window.__rrMallIsAppWebView__(ua?)，layout bootstrap / bootstrap-shop 须在 head 尽早引入。
 */
(function attachRrMallIsAppWebView() {
  function __rrMallIsAppWebView__(ua) {
    var s =
      ua != null
        ? String(ua)
        : typeof navigator !== 'undefined'
          ? navigator.userAgent || ''
          : '';
    return /RR_MALL_(Android|IOS|Harmony)/i.test(s);
  }
  if (typeof window !== 'undefined') {
    try {
      Object.defineProperty(window, '__rrMallIsAppWebView__', {
        value: __rrMallIsAppWebView__,
        writable: false,
        configurable: false
      });
    } catch (e) {
      window.__rrMallIsAppWebView__ = __rrMallIsAppWebView__;
    }
  }
})();
